export default "<p translate [innerHTML]=\"safeHtml\"></p>\r\n"